import * as cssVariables from 'cssVariables';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: cssVariables.grey100,
    height: 230,
    padding: 10,
  },
  title: {
    padding: 15,
    fontSize: cssVariables.fontSizes.medium,
    fontWeight: cssVariables.fontWeights.bold,
  },
  icon: {
    '& > svg': {
      height: 55,
      width: 55,
    },
    '& path': {
      fill: cssVariables.grey500,
    },
  },
};
